import { render, staticRenderFns } from "./ScaleBox.vue?vue&type=template&id=9ba10f0a&scoped=true"
import script from "./ScaleBox.vue?vue&type=script&lang=js"
export * from "./ScaleBox.vue?vue&type=script&lang=js"
import style0 from "./ScaleBox.vue?vue&type=style&index=0&id=9ba10f0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba10f0a",
  null
  
)

export default component.exports